import { Badge } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { DropdownButton, Flex, Icon } from 'ui';
import { getAmountFilters } from 'utils/helpers';
import { additionalTabTypes } from '../../../utils/app-configs';
import { resetAllAdditionalFilterParams } from '../../containers/worklist-actions';

const SortFlex = styled(Flex)`
  border-left: 1px solid ${p => p.theme.colors.border};
  padding-left: 15px;
`;

const StyledBadge = styled(Badge)`
  .ant-badge-count {
    background: #fff;
    color: #6f7e95;
    height: 15px;
    line-height: 15px;
    margin-left: 8px;
    margin-top: -2px;
  }

  .ant-badge-multiple-words {
    padding: 0 5px;
  }
`;

const StyledSpan = styled.span`
  margin: 0 5px;
`;

const StyledIcon = styled(Icon)`
  color: #fff;
`;

const FilterButton = ({
  activeFilters,
  isLoading = false,
  filters = [],
  fixedFilterValues = {},
  intl,
  urlKey = 'filterselect',
  updateCb,
  additionalActionTypes = [],
}) => {
  const [amount, setAmount] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (filters?.length) {
      setAmount(getAmountFilters(activeFilters, filters, false, fixedFilterValues));
    }
  }, [activeFilters, filters?.length]);

  const openFilters = (id = additionalTabTypes.filters) => {
    navigate(urlKey, { state: { openTabId: id } });
  };

  const resetFilters = () => {
    dispatch(updateCb(fixedFilterValues));
    dispatch(resetAllAdditionalFilterParams(true));
  };

  const additionalActions = additionalActionTypes?.map(a => (
    {
      text: intl.formatMessage({ id: `worklist.filters.EDIT_${a?.toUpperCase()}` }),
      onClick: () => openFilters(a),
    }
  ));

  const actions = [
    {
      text: intl.formatMessage({ id: 'worklist.filters.EDIT_FILTERS' }),
      onClick: () => openFilters(additionalTabTypes.filters),
    },
    {
      text: intl.formatMessage({ id: 'worklist.filters.REMOVE_FILTERS' }),
      disabled: amount === 0,
      onClick: resetFilters,
    },
    ...additionalActions,
  ]?.filter(a => a);

  return (
    <SortFlex data-test-id='filter-button'>
      <DropdownButton
        type='secondary'
        onClick={() => openFilters(additionalTabTypes.filters)}
        disabled={isLoading}
        uppercase={true}
        text={
          <>
            <StyledIcon type='filter' />
            <StyledSpan>
              {intl.formatMessage({ id: 'worklist.filters.FILTERS' })}
            </StyledSpan>
            <StyledBadge showZero={true} count={amount < 0 ? 0 : amount} />
          </>
        }
        subItems={actions}
      />
    </SortFlex>
  );
};

FilterButton.propTypes = {
  isLoading: PropTypes.bool,
  activeFilters: PropTypes.object,
  filters: PropTypes.array,
  intl: PropTypes.object,
  fixedFilterValues: PropTypes.object,
  urlKey: PropTypes.string,
  updateCb: PropTypes.func,
  additionalActionTypes: PropTypes.array,
};

export default injectIntl(FilterButton);
